var FieldEditorServiceImpl_1;
var _a;
import { __decorate, __metadata, __param } from "tslib";
// @ts-nocheck
import _ from 'lodash';
import { getVoteCommentsInfo, logVoteToggleState, postVote, voteInit } from 'library-@/apis/workspace_api/vote';
import FieldEditor from './FieldEditor.vue';
import { Toast } from 'patsnap-biz';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { DialogManager } from '@patsnap/tahiti-core/services/dialog-manager';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { FieldEditorService } from './field-editor-service.interface';
const FULL_WIDTH = 752;
let FieldEditorServiceImpl = class FieldEditorServiceImpl {
    static { FieldEditorServiceImpl_1 = this; }
    constructor(ptDialogAutoMounterManager) {
        this.ptDialogAutoMounterManager = ptDialogAutoMounterManager;
        this.folderId = '';
        this.spaceId = '';
        this.timezone = {};
        this.x = 0;
        this.y = 0;
        this.h = 320;
        this.w = 420;
        this.minH = 320;
        this.minW = 420;
        this.maxH = 580;
        this.maxW = 752;
        this.extraSpace = 8;
        this.isShow = false;
        this.isDragging = false;
        this.isResizing = false;
        this.clientRectCache = null;
        this.value = null;
        this.aiCheckTip = false;
        this.filterWords = '';
        this.structor = null;
        this.field = null;
        this.row = null;
        this.newValue = null;
        this.changed = false;
        this.innerIsShowComments = false;
        this.isSpaceOwner = false;
        this._openSrcElement = null;
        this.mouseMoveHandler = null;
        this.mouseupHandler = null;
        this.onValueUpdateFn = _.noop;
        this.onFinalSubmitFn = _.noop;
        this._i18n = null;
        this.voteStatus = {
            allow: true,
            enabled: false,
            data: null,
            nodeId2voters: {},
        };
    }
    static { this.Dialog = FieldEditor; }
    get id() {
        return `field$-${this.folderId}-${this.field?.field_id}`;
    }
    get utcOffset() {
        return this.timezone?.utc_offset;
    }
    // 是否可以拖拽，否则需要自行使用 <FieldEditorService.Dialog v-if="isShow"/> 组件
    get draggableDialogMode() {
        return !!this.ptDialogAutoMounterManager;
    }
    get isShowComments() {
        return this.voteStatus.enabled && this.innerIsShowComments;
    }
    set isShowComments(val) {
        if (!this.voteStatus.enabled) {
            console.error('isShowComments dont enabled');
        }
        this.innerIsShowComments = val;
    }
    get currentUserId() {
        return this.currentUser?.user_id || '';
    }
    get permissionsForComment() {
        return {
            isOwner: this.isSpaceOwner,
            edit: this.voteStatus.allow, // 能投票其实就可评论
        };
    }
    get statusClass() {
        if (!this.isShow)
            return {};
        return {
            'field-editor__draging': this.isDragging,
            'field-editor__resizing': this.isResizing,
        };
    }
    get dragCanvas() {
        return document.body;
    }
    initEditorRect(target = this._openSrcElement) {
        // 优先计算左下区域，再右下，其次左上，最后右上
        if (!target)
            return;
        // @ts-ignore
        const { left, top, right, bottom } = target.getBoundingClientRect();
        const { clientWidth, clientHeight } = this.clientRect;
        const isLeftEnough = left > this.w + this.extraSpace;
        const isTopEnough = top > this.h + this.extraSpace;
        const isRightEnough = clientWidth - right > this.w + this.extraSpace;
        const isBottomEnough = clientHeight - bottom > this.h + this.extraSpace;
        const _x = {
            left: left - this.w - this.extraSpace,
            right: right + this.extraSpace,
        };
        const _y = {
            top: top - this.h,
            bottom: bottom,
        };
        const center = {
            x: (clientWidth - this.w) / 2,
            y: (clientHeight - this.h) / 2,
        };
        if (isLeftEnough && isBottomEnough) {
            // 左下
            this.x = _x.left;
            this.y = _y.bottom;
        }
        else if (isRightEnough && isBottomEnough) {
            // 右下
            this.x = _x.right;
            this.y = _y.bottom;
        }
        else if (isLeftEnough && isTopEnough) {
            // 左上
            this.x = _x.left;
            this.y = _y.top;
        }
        else if (isRightEnough && isTopEnough) {
            // 右上
            this.x = _x.right;
            this.y = _y.top;
        }
        else if (isBottomEnough) {
            // 下 左右居中
            this.x = center.x;
            this.y = _y.bottom;
        }
        else if (isTopEnough) {
            // 上 左右居中
            this.x = center.x;
            this.y = _y.top;
        }
        else if (isLeftEnough) {
            // 左 上下居中
            this.x = _x.left;
            this.y = center.y;
        }
        else if (isRightEnough) {
            // 右 上下居中
            this.x = _x.right;
            this.y = center.y;
        }
        else {
            // 居中
            this.x = center.x;
            this.y = center.y;
        }
        return this;
    }
    get editorStyles() {
        const w = this.isShowComments ? FULL_WIDTH : this.w;
        return {
            left: `${this.x}px`,
            top: `${this.y}px`,
            width: `${w}px`,
            height: `${this.h}px`,
            border: this.draggableDialogMode ? '1px solid #dfe1e6' : 'unset',
        };
    }
    get clientRect() {
        if (!this.clientRectCache) {
            const { clientWidth, clientHeight } = this.dragCanvas;
            this.clientRectCache = { clientWidth, clientHeight };
        }
        return this.clientRectCache;
    }
    setNewValue(newValue, changed) {
        this.newValue = newValue;
        this.changed = changed;
        this.onValueUpdateFn(newValue);
        return this;
    }
    clearMouseMoveEvent() {
        if (this.mouseMoveHandler) {
            this.dragCanvas.removeEventListener('mousemove', this.mouseMoveHandler);
        }
        this.dragCanvas.dataset.fieldEditorDragging = String(false);
    }
    dragEditor(event) {
        if (!this.draggableDialogMode) {
            return;
        }
        // 计算相对位置
        const { x, y } = event;
        const offsetX = x - this.x;
        const offsetY = y - this.y;
        this.clientRectCache = null;
        const { clientWidth, clientHeight } = this.clientRect;
        this.clearMouseMoveEvent();
        this.mouseMoveHandler = _.throttle((mousemoveEvent) => {
            this.isDragging = true;
            let _x = mousemoveEvent.x - offsetX;
            let _y = mousemoveEvent.y - offsetY;
            const _left = clientWidth - this.w;
            const _top = clientHeight - this.h;
            if (_x <= this.extraSpace)
                _x = this.extraSpace;
            if (_x >= _left - this.extraSpace)
                _x = _left - this.extraSpace;
            if (_y <= this.extraSpace)
                _y = this.extraSpace;
            if (_y >= _top - this.extraSpace)
                _y = _top - this.extraSpace;
            this.x = _x;
            this.y = _y;
        }, 0);
        this.dragCanvas.addEventListener('mousemove', this.mouseMoveHandler);
        this.resetOnMouseUp();
    }
    resizeEditor() {
        if (!this.draggableDialogMode) {
            return;
        }
        this.clientRectCache = null;
        const { clientWidth, clientHeight } = this.clientRect;
        this.clearMouseMoveEvent();
        this.mouseMoveHandler = _.throttle((mousemoveEvent) => {
            this.isResizing = true;
            const { clientX, clientY } = mousemoveEvent;
            let _w = Math.min(Math.max(clientX - this.x, this.minW), this.maxW);
            let _h = Math.min(Math.max(clientY - this.y, this.minH), this.maxH);
            if (_w + this.x + this.extraSpace > clientWidth) {
                _w = clientWidth - this.x - this.extraSpace;
            }
            if (_h + this.y + this.extraSpace > clientHeight) {
                _h = clientHeight - this.y - this.extraSpace;
            }
            if (this.isShowComments) {
                this.h = _h;
            }
            else {
                this.w = _w;
                this.h = _h;
            }
        }, 0);
        this.dragCanvas.addEventListener('mousemove', this.mouseMoveHandler);
        this.dragCanvas.dataset.fieldEditorDragging = String(true);
        this.resetOnMouseUp();
    }
    resetOnMouseUp() {
        this.clearMouseUpEvent();
        this.mouseupHandler = () => {
            this.clearMouseMoveEvent();
            this.isResizing = false;
            this.isDragging = false;
        };
        this.dragCanvas.addEventListener('mouseup', this.mouseupHandler);
    }
    clearMouseUpEvent() {
        if (this.mouseupHandler) {
            this.dragCanvas.removeEventListener('mouseup', this.mouseupHandler);
            this.mouseupHandler = null;
        }
    }
    hide() {
        if (!this.isShow)
            return;
        // 阻止隐藏
        if (!this.isDragging && !this.isResizing) {
            this.showDialog(false);
            Object.assign(this.voteStatus, {
                enabled: false,
                data: null,
                nodeId2voters: {},
            });
        }
        // 提交修改
        if (this.changed) {
            setTimeout(() => {
                this.onFinalSubmitFn({
                    newValue: this.newValue,
                    oldValue: this.value,
                });
            }, 18);
        }
        return this;
    }
    setEditor(status) {
        if (!status) {
            this.h = 268;
            this.w = 262;
        }
        else {
            this.h = 300;
            this.w = FULL_WIDTH;
        }
    }
    onValueUpdate(onValueUpdateFn) {
        this.onValueUpdateFn = onValueUpdateFn;
        return this;
    }
    onSubmit(onFinalSubmitFn) {
        this.onFinalSubmitFn = onFinalSubmitFn;
        return this;
    }
    get isPatentField() {
        return this.row.PATENT_ID;
    }
    get i18n() {
        if (!this._i18n) {
            console.error('no i18n');
        }
        return this._i18n;
    }
    set i18n(_i18n) {
        this._i18n = _i18n;
    }
    showDialog(bol) {
        this.isShow = bol;
        if (this.draggableDialogMode) {
            this.ptDialogAutoMounterManager.update(FieldEditorServiceImpl_1.Dialog, {
                service: this,
            });
            this.ptDialogAutoMounterManager.toggleOpenState(FieldEditorServiceImpl_1.Dialog, bol);
        }
    }
    open({ target, field, value, row, folderId, spaceId, aiCheckTip, }) {
        const { field_option_value, field_layer_value } = field;
        if (['OPTION', 'LAYER'].indexOf(field.field_type) === -1) {
            throw new Error('field type is not OPTION or LAYER');
        }
        if (!folderId || !spaceId) {
            throw new Error('folderId or spaceId is required');
        }
        this.folderId = folderId;
        this.spaceId = spaceId;
        this.field = field;
        this.value = Array.isArray(value) ? [...value] : [];
        this.row = row;
        this.structor = field.field_type === 'OPTION' ? field_option_value : field_layer_value;
        this.clientRectCache = null;
        this._openSrcElement = target;
        this.changed = false;
        this.newValue = null;
        this.aiCheckTip = aiCheckTip;
        if (this.isPatentField) {
            voteInit({
                folder_id: this.folderId,
                field_id: this.field.field_id,
            }).then((d) => {
                this.voteStatus.allow = d.can_vote;
                if (!this.voteStatus.allow) {
                    this.voteStatus.enabled = false;
                }
                else {
                    this.voteStatus.enabled = d.vote_switch;
                }
                this.currentUser = d.user_info;
                this.isSpaceOwner = d.space_owner;
                this.timezone = d.timezone;
            });
            this.showDialog(true);
        }
        else {
            this.voteStatus.allow = false;
            this.voteStatus.enabled = false;
            this.showDialog(true);
        }
        return this;
    }
    destroy() {
        this.clearMouseMoveEvent();
        this.clearMouseUpEvent();
        this.filterWords = '';
        Object.assign(this.voteStatus, {
            enabled: false,
            data: null,
            nodeId2voters: {},
        });
        this.ptDialogAutoMounterManager.unregister(FieldEditorServiceImpl_1.Dialog);
    }
    get commonVoteParams() {
        return {
            folder_id: this.folderId,
            field_id: this.field.field_id,
            data_type: 'PATENT',
            data_id: this.row.PATENT_ID,
        };
    }
    async updateVoteCommentsInfo() {
        const d = await getVoteCommentsInfo(this.commonVoteParams);
        this.setVoteStatusByResp(d);
    }
    toggleComments(status) {
        if (status) {
            this.isShowComments = true;
            if (this.draggableDialogMode) {
                this.w = this.maxW;
            }
            else {
                this.setEditor(status);
            }
        }
        else {
            this.isShowComments = false;
            if (this.draggableDialogMode) {
                this.w = this.minW;
            }
            else {
                this.setEditor(status);
            }
        }
    }
    setVoteStatusByResp(resp) {
        this.voteStatus.data = resp;
        this.voteStatus.nodeId2voters = {};
        this.voteStatus.data.node_vote_info.forEach(votesInfo => {
            this.voteStatus.nodeId2voters[votesInfo.node_id] = {
                ...votesInfo,
                currentUserIncluded: !!_.find(votesInfo.voters, { user_id: this.currentUserId }),
            };
        });
    }
    getVotersInfoByNodeId(nodeId) {
        return this.voteStatus.nodeId2voters[nodeId] || {};
    }
    async toggleVoteMode() {
        if (!this.voteStatus.allow)
            return;
        this.voteStatus.enabled = !this.voteStatus.enabled;
        if (this.voteStatus.enabled) {
            // do noting, 改成放在组件里更新数据了
        }
        else {
            this.toggleComments(false);
        }
        await logVoteToggleState(this.voteStatus.enabled, _.pick(this.commonVoteParams, ['folder_id', 'field_id']));
    }
    async vote(bol, nodeId) {
        const d = await postVote(bol, {
            node_id: nodeId,
            ...this.commonVoteParams,
        });
        if (d.status) {
            this.setVoteStatusByResp(d.data);
        }
        else {
            if (d.error_code) {
                Toast({
                    message: this._i18n.t(`commonStatusCode.${d.error_code}`),
                    type: 'error',
                    showClose: true,
                });
            }
            else {
                Toast({
                    message: d.error_msg,
                    type: 'error',
                    showClose: true,
                });
            }
        }
    }
};
FieldEditorServiceImpl = FieldEditorServiceImpl_1 = __decorate([
    injectable(),
    __param(0, inject(DialogManager)),
    __metadata("design:paramtypes", [typeof (_a = typeof DialogManager !== "undefined" && DialogManager) === "function" ? _a : Object])
], FieldEditorServiceImpl);
export { FieldEditorServiceImpl };
export function getFieldEditorServiceInstance() {
    return injectService(FieldEditorService);
}
export function destroyFieldEditorServiceInstance() {
    const fieldEditorServiceInstance = injectService(FieldEditorService);
    if (fieldEditorServiceInstance) {
        fieldEditorServiceInstance.destroy();
    }
}
